import { centerMiddleElementInScrollableContainer, scrollOnHover } from 'scrollable';
import SlideCarousel from 'slide-carousel';

export function initDesignerQuotesList() {
    const requestDesignerQuotesListSelector = '[data-scrollable="requestDesignerQuotesList"]';
    const requestDesignerQuotesList = document.querySelector(requestDesignerQuotesListSelector);
    if (requestDesignerQuotesList) {
        scrollOnHover(requestDesignerQuotesListSelector);
        centerMiddleElementInScrollableContainer(requestDesignerQuotesListSelector);
    }

    const designerCards = document.querySelectorAll('[data-design-card-carousel]');
    Array.from(designerCards).forEach(designerCard => {
        new SlideCarousel({
            element: designerCard,
            stepElement: designerCard.querySelector('[data-carousel-steps]'),
            stepClickEventMessage: 'Clicked designer card step',
        });
    });
}
